import { lazy, Suspense, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '#components/Button'
import { Icon } from '#components/Icon'
import { Spinner } from '#components/Spinner'
import type { ErrorDescription } from '#features/ErrorHandling/errorHelpers'
import ReportIcon from '#icons/report-filled.svg'
import { sharedTestIds } from '#utils/sharedTestIds'

const LazyReportErrorDialog = lazy(async () => {
  const { ReportErrorDialog } = await import('#features/ErrorHandling/ReportErrorDialog.tsx')
  return { default: ReportErrorDialog }
})

export const ErrorReportButton = ({ errorInfo }: { errorInfo: ErrorDescription[] }) => {
  const { t } = useTranslation('shared')
  const [isReportDialogOpen, setIsReportDialogOpen] = useState(false)

  return (
    <Suspense
      fallback={
        <Button className="button" disabled data-testid={sharedTestIds.error.reportButton}>
          <Spinner size="s" />
          {t('error-handler.button.report', 'Report')}
        </Button>
      }
    >
      <Button className="button" onClick={() => setIsReportDialogOpen(true)} data-testid={sharedTestIds.error.reportButton}>
        <Icon iconUrl={ReportIcon} size="s" />
        {t('error-handler.button.report', 'Report')}
      </Button>

      {isReportDialogOpen && <LazyReportErrorDialog errorInfo={errorInfo} onOpenChange={setIsReportDialogOpen} isOpen={isReportDialogOpen} />}
    </Suspense>
  )
}
